import React from 'react'
import infoWarning from '../../assets/bulb-yellow.svg'
import './cards.css'
import failureOutlineIcon from "../../assets/close-icon.svg";

const InfoCard: React.FunctionComponent<{ status: 'warning' | 'error', message: string }> = ({ message, status }) => {
    
    const infoClass = status === 'warning' ? 'info-card-warning' : 'info-card-error'

  return (
    <div className={"d-flex align-items-center info-card " + infoClass}>
        <img width={26} height={26} className='me-3' src={ status === 'warning' ? infoWarning : failureOutlineIcon } alt="info" />
        <p className="mb-0 font-14 weight-500">{ message }</p>
    </div>
  )
}

export default InfoCard
